import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Stats } from '../components/sections/Stats';
import { PainPoints } from '../components/sections/PainPoints';
import { Testimonials } from '../components/sections/Testimonials';
import { BonusOffer } from '../components/sections/BonusOffer';
import { Includes } from '../components/sections/Includes';
import { Pricing } from '../components/sections/Pricing';
import { FAQ } from '../components/sections/FAQ';
import { FinalCTA } from '../components/sections/FinalCTA';
import { Footer } from '../components/sections/Footer';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { MetaPixel } from '../components/MetaPixel';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-brand-dark" data-id="element-226">
      <MetaPixel data-id="element-227" />
      <main data-id="element-228">
        <Hero data-id="element-229" />
        <Stats data-id="element-230" />
        <PainPoints data-id="element-231" />
        <Includes data-id="element-232" />
        <Testimonials data-id="element-233" />
        <BonusOffer data-id="element-234" />
        <Pricing data-id="element-235" />
        <FAQ data-id="element-236" />
        <FinalCTA data-id="element-237" />
      </main>
      <Footer data-id="element-238" />
      <SocialProofPopup data-id="element-239" />
    </div>;
}